import { HttpParams } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { SetLogin } from 'src/app/Models/Access/set-login';
import { GetCommunityAccessResult } from 'src/app/Models/Account/getComunityAccess';
import { ProductByCategoriesResult } from 'src/app/Models/Product/productsCategories_model';
import { ProductByCompaniesResult } from 'src/app/Models/Product/product_model';
import { AppStateService } from '../AppState/app-state.service';
import { ConstService } from '../Const/const.service';
import { getCookie, getLocalStorage, getToken, setLocalStorage } from 'npx-arc-ui/utils';
import { productAccessControlListResult } from 'src/app/Models/Product/access_product';
import Base from 'src/app/Models/Base/base';
import Storage from 'src/app/Models/Base/storage';
import ProductModulesResult, { Item } from 'src/app/Models/Product/product_modules.model';
import access_token from 'src/app/Models/Base/token';
import { environment } from 'src/environments/environment';
export class ProductService {
  constructor(
    private appState: AppStateService) { }

  GetModuleERP(): Observable<{ success: boolean, item: Item | null }> {
    const
      url = `${ConstService.URLApi}/Product/GetModule`,
      params = new HttpParams()
        .set('Page', 0)
        .set('ItemsPerPage', 1)
        .set('GetDeleted', false)
        .set('GetRandom', true);
    return this.appState.http.get<ProductModulesResult>(url, { params }).pipe(
      tap(resp => {
        if (!resp.success) {
          throw (resp.message)
        }
        if (resp.success && !resp.items.length) {
          throw ('No se encontraron módulos')
        }
      }),
      map(({ items, success }: ProductModulesResult) => {
        return {
          item: items[items.length - 1]
          , success
        }
      }),
      catchError(c => {
        return of({
          success: false,
          item: null
        })
      })
    )

  }

  GetCommunityAccess() {
    let url = `${ConstService.URLApi}/Product/GetCommunityAccess`;
    return this.appState.http.get<GetCommunityAccessResult>(url).pipe(
      tap((res) => {
        if (res.success) {
          this.appState.GetCommunityAccessResult = res;
        } else {
          this.appState.showMiniMessage(res.message, 'error');
        }
      }),
      catchError((err) => {
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  GetProductsByCategories() {
    let url = `${ConstService.URLApi}/Product/GetProductsByCategories`;
    return this.appState.http.get<ProductByCategoriesResult>(url).pipe(
      tap(res => {
        if (res.success) {
          this.appState.ProductByCategoriesRes = res;
        } else {
          throw (res.message)
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  myAccountModal(code: string) {
    this.appState.loading = !false;
    let url = `${ConstService.URLApi}/Product/SetProductLogin?Code=${code}`;
    let params = new HttpParams();
    const expirationDate = getLocalStorage<string>(Storage.EMAIL)!.expiration

    if (!!expirationDate.length) {
      params = params.append('expirationDate', expirationDate);
    }

    this.appState.http.get<SetLogin>(url, { params }).subscribe(
      (res) => {
        if (res.success) {
          this.appState.loading = false;
          this.appState.urlIframe = res.url;
          this.appState.productName = 'Mi Cuenta';
        } else {
          this.appState.loading = false;
          this.appState.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  EquifaxModal(code: string) {
    this.appState.loading = true;
    let url = `${ConstService.URLApi}/Product/SetProductLogin?Code=${code}`;
    let params = new HttpParams();
    const expirationDate = getLocalStorage<string>(Storage.EMAIL)!.expiration

    if (!!expirationDate.length) {
      params = params.append('expirationDate', expirationDate);
    }
    this.appState.http.get<SetLogin>(url, { params }).subscribe(
      (res) => {
        if (res.success) {
          this.appState.loading = false;
          this.appState.urlIframe = res.url;
        } else {
          this.appState.loading = false;
          this.appState.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  setErpLogin(code: string, isPublic: boolean, name: string, userId?: string, openProduct: boolean = false) {
    if (!this.appState.returnProduct.length) {
      this.appState.loading = true;
    }

    let url = `${ConstService.URLApi}/Product/SetProductLogin`;
    
    let params = new HttpParams().set('Code', code);
    if (userId && !!userId.length) {
      params = params.append('userID', userId);
    }
    const 
    DEFONTANA_FINTECH = 'Defontana Fintech',
    storageData = getLocalStorage<string>(Storage.EMAIL);

    if (storageData && storageData.expiration) {
      const expirationDate = storageData.expiration;
      params = params.append('expirationDate', expirationDate);
    } else {
     this.appState.onLogOut();
    }

    this.appState.http.get<SetLogin>(url, { params }).subscribe(
      (res) => {   
        if (res.success) {
          this.appState.loading = false;          
          if (!!this.appState.returnProduct.length) {
            window.open(res.url.toString(), '_self')?.focus();
            this.appState.returnProduct = '';
          } else {
            if(openProduct)
              {
                window.open(res.url.toString(), '_self')?.focus();
              }
              else
              {
                window.open(res.url.toString(), '_blank')?.focus();
              }
            
          }

          if(DEFONTANA_FINTECH.includes(name) && environment.production){
            const token = getCookie(Storage.ACCESS_TOKEN);
            let client, user;
            if (token) {
              ({ client, user } = getToken<access_token>(token) || {});
            }else{
              console.error('No access token found');
            }
            const 
            user_id = userId ? `${client}_${userId}` : `${client}_${user}`,
            config = this.appState.intercom.intercom_config(user_id)
            this.appState.intercom.boot(config);
          }


        } else {
          this.appState.loading = false;
          this.appState.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  searchProducts(text: string) {
    let url = `${ConstService.URLApi}/Product/SearchProducts`;
    let params = new HttpParams().set('text', text);
    this.appState.http.get<ProductByCompaniesResult>(url, { params }).subscribe(
      (res) => {
        if (res.success) {
          this.appState.SearchProductByCompanie = res;
        } else {
          this.appState.showMiniMessage(res.message, 'error');
        }
      },
      (err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
      }
    );
  }

  GetProductsByCompanyAndUser() {
    let url = `${ConstService.URLApi}/Product/GetProductsByCompanyAndUser`;
    let params = new HttpParams();
    const storageData = getLocalStorage<string>(Storage.EMAIL);

    if (storageData && storageData.expiration) {
      const expirationDate = storageData.expiration;
      params = params.append('expirationDate', expirationDate);
    } else {
     this.appState.onLogOut();
    }

    return this.appState.http.get<ProductByCompaniesResult>(url, { params }).pipe(
      tap(({ success, message,isBlockedUser }) => {
        this.appState.usuarioBloqueado = isBlockedUser;
        if (!success) {
          throw message
        }
      }),
      catchError((err) => {
        this.appState.showMiniMessage(
          err || 'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  GetProductsAccessControl() {
    this.appState.loading = true;
    let url = `${ConstService.URLApi}/Admin/GetProductsAccessControl`;
    return this.appState.http.get<productAccessControlListResult>(url).pipe(
      tap((res) => {
        this.appState.loading = false;
        if (res.success) {
          this.appState.ListproductAccess = res;
        } else {
          throw (res.message);
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage(
          'Error interno, por favor intentar más tarde.',
          'error'
        );
        return throwError(err);
      })
    );
  }

  SetProductsAccessControl(productID: string, adminAccess: boolean): Observable<Base> {
    this.appState.loading = true;
    const url: string = `${ConstService.URLApi}/Admin/SetProductsAccessControl`;

    return this.appState.http.post<Base>(url, { productID, adminAccess }).pipe(
      tap((res) => {
        this.appState.loading = false;
        if (res.success) {
          this.appState.showMiniMessage(res.message, 'success');
        } else {
          throw (res.message);
        }
      }),
      catchError((err) => {
        this.appState.loading = false;
        this.appState.showMiniMessage('Error interno, por favor intentar más tarde.', 'error');
        return throwError(err);
      })
    );
  }
}
